class AuthProvider {
  #logoutSuccessUrl;

  getLogoutSuccessUrl() {
    return this.#logoutSuccessUrl;
  }

  set(data) {
    const { logoutSuccessUrl } = data;
    this.#logoutSuccessUrl = logoutSuccessUrl;
    return data;
  }
}

export default new AuthProvider();
